import { useGetSellersQuery } from 'services/api';
import styled from 'styled-components';
import { ContainedFormReactSelect } from '../../../Form/FinalForm/Contained/ContainedFormReactSelect';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 60px;
  div:first-child {
    flex: 1 1 80%;
  }
`;

const onMenuOpen = () => {
  document.body.style.touchAction = 'none';
  document.body.style.overflow = 'hidden';
};

const onMenuClose = () => {
  document.body.style.touchAction = '';
  document.body.style.overflow = '';
};

export const SellerField = ({ userOptions }: { userOptions: Array<{ value: number; label: string }> }) => {
  return (
    <Wrapper>
      <ContainedFormReactSelect
        onMenuClose={onMenuClose}
        onMenuOpen={onMenuOpen}
        menuPosition="absolute"
        label="Seller"
        name="seller_id"
        options={userOptions}
      />
    </Wrapper>
  );
};
